import { render, staticRenderFns } from "./sort_operate.vue?vue&type=template&id=6bc9de93&scoped=true"
import script from "./sort_operate.vue?vue&type=script&lang=js"
export * from "./sort_operate.vue?vue&type=script&lang=js"
import style0 from "./sort_operate.vue?vue&type=style&index=0&id=6bc9de93&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc9de93",
  null
  
)

export default component.exports